import { useState, useEffect } from 'react';
import api from '../api';

let cachedAuth = null;
let fetchPromise = null;

/**
 * Shared hook that fetches and caches B2 thumbnail auth token.
 * All ContentCard instances share the same cached value.
 */
export function useThumbnailAuth() {
  const [auth, setAuth] = useState(cachedAuth);

  useEffect(() => {
    if (cachedAuth) {
      setAuth(cachedAuth);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = api.get('/content/thumbnail-auth')
        .then(({ data }) => {
          cachedAuth = data;
          return data;
        })
        .catch(() => null);
    }

    fetchPromise.then((data) => {
      if (data) setAuth(data);
    });
  }, []);

  return auth;
}
